// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as User_Types_Utils$DvmAdminFrontendFr from "../../../context/user/User_Types_Utils.bs.js";

function actualOrderType(order, lastCorrectionValues) {
  var ord = Belt_Option.getWithDefault(order.header.orderOrderType, /* NOTSET */16);
  if (ord < 7) {
    return ord;
  }
  switch (ord) {
    case /* EP */7 :
    case /* ES */8 :
    case /* RP */9 :
    case /* RS */10 :
    case /* AP */14 :
    case /* AS */15 :
        break;
    case /* SM */11 :
    case /* TT */12 :
    case /* AD */13 :
    case /* NOTSET */16 :
        return ord;
    
  }
  return Belt_Option.mapWithDefault(lastCorrectionValues, ord, (function (x) {
                return Belt_Option.getWithDefault(x.orderType, /* NOTSET */16);
              }));
}

function isResell(orderType) {
  if (orderType < 7) {
    return false;
  }
  switch (orderType) {
    case /* EP */7 :
    case /* ES */8 :
    case /* RP */9 :
    case /* RS */10 :
    case /* AP */14 :
    case /* AS */15 :
        return true;
    case /* SM */11 :
    case /* TT */12 :
    case /* AD */13 :
    case /* NOTSET */16 :
        return false;
    
  }
}

function rolesCanDealerRequest(selectedRole) {
  if (User_Types_Utils$DvmAdminFrontendFr.isAdmin(selectedRole) || User_Types_Utils$DvmAdminFrontendFr.isAdminDealer(selectedRole) || selectedRole === /* Dealer */7 || selectedRole === /* DPR */10) {
    return true;
  } else {
    return selectedRole === /* RMPC */9;
  }
}

export {
  actualOrderType ,
  isResell ,
  rolesCanDealerRequest ,
}
/* No side effect */
